module.exports = __webpack_public_path__ + "img/default-video.af18b524.jpg";